import axios from 'axios';

const getBaseURL = () => {
    // Se houver uma variável de ambiente explícita, usamos essa
    if (process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_URL.startsWith('/')) {
        return process.env.REACT_APP_API_URL;
    }

    const { protocol, hostname, port } = window.location;

    // Synology Fix: Se estamos no porto 8081, o backend está no 5010 (acesso local)
    // Isto evita passar pelo proxy do webpack que pode falhar em algumas redes
    if (port === '8081') {
        console.log('Detected Synology/Local 8081 access. Switching directly to backend port 5010.');
        return `${protocol}//${hostname}:5010/api`;
    }

    // Acesso Externo (DDNS) ou Proxy Standard: usar caminho relativo
    return '/api';
};

const api = axios.create({
    baseURL: getBaseURL(),
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json'
    }
});

console.log('API Service Initialized. BaseURL:', api.defaults.baseURL);

// Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para lidar com erros de resposta
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Se receber 401 (Não autorizado), fazer logout
        if (error.response && error.response.status === 401) {
            // Não fazer redirect automático se estiver na página de login
            if (!window.location.pathname.includes('/login')) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
